import React from 'react';
import {
	HouseIcon,
	UserIcon,
	UsersIcon,
	BriefcaseIcon,
	MegaphoneIcon,
	PlusIcon,
	EnvelopeIcon,
	PaperclipIcon,
	DeviceMobileIcon,
	WhatsappLogoIcon,
	PhoneIcon,
	GraduationCapIcon,
	ChartBarIcon,
	ChalkboardIcon,
	ImageIcon,
	FlagIcon,
	NewspaperIcon,
	ListBulletsIcon,
	BrowserIcon,
	BookIcon,
} from '@phosphor-icons/react';

import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro';
import { hasAnyRights, hasRights, hasServiceRights, isSuperAdmin, isMSSPAdmin } from './utils/rights';

const navigation = {
	getNavMenuItems: (user, currentCustomer) => {
		const _nav = [
			{
				component: CNavItem,
				name: 'Dashboard',
				to: '/dashboard',
				classNames: 'dashboard',
				icon: <HouseIcon weight="bold" className='nav-icon' size={16} />,
				show: true,
			},
			// {
			//   component: CNavItem,
			//   name: "Profile",
			//   to: "/profile",
			//   icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
			//   show: true,
			// },
			{
				component: CNavTitle,
				name: 'MANAGE',
				show: hasAnyRights(user, [
					'can_view_email_campaigns',
					'can_edit_email_campaigns',
					'can_view_sms_campaigns',
					'can_edit_sms_campaigns',
					'can_view_whatsapp_campaigns',
					'can_edit_whatsapp_campaigns',
					'can_view_voice_campaigns',
					'can_edit_voice_campaigns',
				]),
			},
			{
				component: CNavItem,
				name: 'Platform Users',
				to: '/users',
				icon: <UserIcon weight="bold" className='nav-icon' size={16} />,
				// Platform users are staff-level (route is [0,1]); MSSP admins manage
				// users only within customers they own, via the customer Users page.
				show: hasRights(user, ['can_view_users']) && !isMSSPAdmin(user),
			},
			{
				component: CNavItem,
				name: 'Users',
				to: '/address-book',
				classNames: 'users',
				icon: <UsersIcon weight="bold" className='nav-icon' size={16} />,
				show: hasRights(user, ['can_view_employees']),
			},
			{
				component: CNavItem,
				name: 'Customers',
				to: '/customers',
				icon: <BriefcaseIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_clients']),
			},

			// {
			// 	component: CNavItem,
			// 	name: 'Clients',
			// 	to: '/dashboard',
			// 	icon: <CIcon icon={cilSpeedometer} customClassName='nav-icon' />,
			// 	show: true,
			// 	// badge: {
			// 	//   color: 'info-gradient',
			// 	//   text: 'NEW',
			// 	// },
			// },

			// {
			// 	component: CNavGroup,
			// 	name: 'Client Management',
			// 	to: '/customers',
			// 	icon: <CIcon icon={cilBuilding} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_clients', 'can_edit_clients']),
			// 	items: [

			// 		{
			// 			component: CNavItem,
			// 			name: 'Create Client',
			// 			to: '/create/client',
			// 			icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_edit_clients']),
			// 		},
			// 	],
			// },

			{
				component: CNavTitle,
				name: hasServiceRights('email', currentCustomer) ? 'PHISHING SIMULATOR' : 'AWARENESS CAMPAIGNS',
				show: hasAnyRights(user, [
					'can_view_email_campaigns',
					'can_edit_email_campaigns',
					'can_view_sms_campaigns',
					'can_edit_sms_campaigns',
					'can_view_whatsapp_campaigns',
					'can_edit_whatsapp_campaigns',
					'can_view_voice_campaigns',
					'can_edit_voice_campaigns',
				]),
			},

			{
				component: CNavGroup,
				name: 'Campaigns',
				to: '/email/templates',
				icon: <MegaphoneIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_email_templates', 'can_edit_email_templates']) && !isSuperAdmin(user),
				items: [
					{
						component: CNavGroup,
						name: 'Create Campaign',
						to: '/campaigns/create',
						icon: <PlusIcon weight="bold" className='nav-icon' size={16} />,
						show: hasAnyRights(user, ['can_edit_email_campaigns']),
						items: [
							{
								component: CNavItem,
								name: 'Email',
								to: '/email/campaigns/create',
								icon: <EnvelopeIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_email_campaigns']) && hasServiceRights('email', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'Email Attachment',
								to: '/attachment/campaigns/create',
								icon: <PaperclipIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_email_campaigns']) && hasServiceRights('email', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'SMS',
								to: '/sms/campaigns/create',
								icon: <DeviceMobileIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_sms_campaigns']) && hasServiceRights('sms', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'Whatsapp',
								to: '/whatsapp/campaigns/create',
								icon: <WhatsappLogoIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_sms_campaigns']) && hasServiceRights('whatsapp', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'Voice',
								to: '/voice/campaigns/create',
								icon: <PhoneIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_voice_campaigns']) && hasServiceRights('voice', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'Training',
								to: '/training/campaigns/create',
								icon: <GraduationCapIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_training_campaigns']) && hasServiceRights('training', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'Email + Training',
								to: '/email-training/campaigns/create',
								icon: <EnvelopeIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_email_campaigns', 'can_edit_training_campaigns']) && hasServiceRights('email_training', currentCustomer),
							},
							{
								component: CNavItem,
								name: 'SMS + Training',
								to: '/sms-training/campaigns/create',
								icon: <DeviceMobileIcon weight="bold" className='nav-icon' size={16} />,
								show: hasRights(user, ['can_edit_sms_campaigns', 'can_edit_training_campaigns']) && hasServiceRights('sms_training', currentCustomer),
							},
						],
					},

					{
						component: CNavItem,
						name: 'Campaign Details',
						to: '/campaigns',
						icon: <ChartBarIcon weight="bold" className='nav-icon' size={16} />,
						show: hasRights(user, ['can_view_campaigns']),
					},
					// {
					//   component: CNavItem,
					//   name: "Phishing Websites",
					//   to: "/landing-pages",
					//   icon: <CIcon icon={cilGlobeAlt} customClassName="nav-icon" />,
					//   show: hasAnyRights(user, ["can_view_email_templates"]),
					// },

					// {
					//   component: CNavItem,
					//   name: "Vishing",
					//   to: "/voice/campaigns",
					//   icon: (
					//     <CIcon icon={cilVoiceOverRecord} customClassName="nav-icon" />
					//   ),
					//   show: hasAnyRights(user, ["can_edit_email_campaigns"]),
					// },
					// {
					//   component: CNavItem,
					//   name: "Smishing",
					//   to: "/sms/campaigns",
					//   icon: <CIcon icon={cilShortText} customClassName="nav-icon" />,
					//   show: hasAnyRights(user, ["can_edit_email_campaigns"]),
					// },
					// {
					//   component: CNavItem,
					//   name: "WhatsApp Message",
					//   to: "/whatsapp/campaigns",
					//   icon: <CIcon icon={cilPhone} customClassName="nav-icon" />,
					//   show: hasAnyRights(user, ["can_edit_email_campaigns"]),
					// },
				],
			},

			{
				component: CNavItem,
				name: 'Phishing Material',
				to: '/templates',
				icon: <EnvelopeIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_email_templates']) && hasServiceRights('email', currentCustomer),
			},

			// {
			// 	component: CNavGroup,
			// 	name: 'SMShing',
			// 	to: '/sms/campaigns',
			// 	icon: <CIcon icon={cilTablet} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_sms_campaigns', 'can_edit_sms_campaigns']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'SMS Campaign List',
			// 			to: '/sms/campaigns',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_sms_campaigns']),
			// 		},

			// 	],
			// },

			// {
			// 	component: CNavGroup,
			// 	name: 'WhatsApp Message',
			// 	to: '/whatsapp/campaigns',
			// 	icon: <CIcon icon={cilTablet} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_whatsapp_campaigns', 'can_edit_whatsapp_campaigns']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'WhatsApp Campaign List',
			// 			to: '/whatsapp/campaigns',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_whatsapp_campaigns']),
			// 		},

			// 	],
			// },

			// {
			// 	component: CNavGroup,
			// 	name: 'Vishing',
			// 	to: '/voice/campaigns',
			// 	icon: <CIcon icon={cilPhone} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_voice_campaigns', 'can_edit_voice_campaigns']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'Voice Campaign List',
			// 			to: '/voice/campaigns',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_voice_campaigns']),
			// 		},

			// 	],
			// },

			// {
			// 	component: CNavTitle,
			// 	name: 'Template Management',
			// 	show: hasAnyRights(user, ['can_view_email_templates', 'can_edit_email_templates', 'can_view_sms_templates', 'can_edit_sms_templates', 'can_view_whatsapp_templates', 'can_edit_whatsapp_templates', 'can_view_voice_templates', 'can_edit_voice_templates']),
			// },
			{
				component: CNavTitle,
				name: 'AWARENESS SPACE',
				show:
					hasAnyRights(user, [
						'can_view_email_campaigns',
						'can_edit_email_campaigns',
						'can_view_sms_campaigns',
						'can_edit_sms_campaigns',
						'can_view_whatsapp_campaigns',
						'can_edit_whatsapp_campaigns',
						'can_view_voice_campaigns',
						'can_edit_voice_campaigns',
					]) && hasServiceRights('training', currentCustomer),
			},
			// {
			//   component: CNavGroup,
			//   name: "Training Modules",
			//   to: "/training-modules",
			//   icon: <CIcon icon={cilLifeRing} customClassName="nav-icon" />,
			//   show: hasAnyRights(user, [
			//     "can_view_email_templates",
			//     "can_edit_email_templates",
			//   ]),
			//   items: [

			//     {
			//       component: CNavItem,
			//       name: "Assign Training",
			//       to: "/training-modules",
			//       icon: <CIcon icon={cilTriangle} customClassName="nav-icon" />,
			//       show: hasAnyRights(user, ["can_view_system_templates"]),
			//     },

			//     // {
			//     // 	component: CNavItem,
			//     // 	name: 'Create Template',
			//     // 	to: '/create/email/template',
			//     // 	icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			//     // 	show: hasAnyRights(user, ['can_edit_email_templates']),
			//     // },
			//   ],
			// },

			{
				component: CNavItem,
				name: 'Training Modules',
				classNames: 'trainingModules',
				to: '/training-modules',
				icon: <ChalkboardIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_system_templates']) && hasServiceRights('training', currentCustomer),
			},

			// {
			//   component: CNavItem,
			//   name: "Campaign Report",
			//   to: "/executive-report",
			//   icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
			//   show: hasRights(user, ["can_view_users"]),
			// },
			// {
			// 	component: CNavGroup,
			// 	name: 'System Templates',
			// 	to: '/system/templates',
			// 	icon: <CIcon icon={cilEnvelopeClosed} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_system_templates', 'can_edit_system_templates']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'List Templates',
			// 			to: '/system/templates',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_system_templates']),
			// 		},
			// 		{
			// 			component: CNavItem,
			// 			name: 'Create Template',
			// 			to: '/create/system/template',
			// 			icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_edit_system_templates']),
			// 		},
			// 	],
			// },
			// {
			// 	component: CNavGroup,
			// 	name: 'Voice Templates',
			// 	to: '/voice/templates',
			// 	icon: <CIcon icon={cilPhone} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_voice_templates', 'can_edit_voice_templates']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'List Templates',
			// 			to: '/voice/templates',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_voice_templates']),
			// 		},
			// 		{
			// 			component: CNavItem,
			// 			name: 'Create Template',
			// 			to: '/create/voice/template',
			// 			icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_edit_voice_templates']),
			// 		},
			// 	],
			// },
			// {
			// 	component: CNavGroup,
			// 	name: 'SMS Templates',
			// 	to: '/sms/templates',
			// 	icon: <CIcon icon={cilTablet} customClassName='nav-icon' />,
			// 	show: hasAnyRights(user, ['can_view_sms_templates', 'can_edit_sms_templates']),
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'List Templates',
			// 			to: '/sms/templates',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_voice_templates']),
			// 		},
			// 		{
			// 			component: CNavItem,
			// 			name: 'Create Template',
			// 			to: '/create/sms/template',
			// 			icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_edit_voice_templates']),
			// 		},
			// 	],
			// },
			// {
			// 	component: CNavTitle,
			// 	name: 'Landing Page Management',
			// 	show: hasAnyRights(user, ['can_view_landing_pages', 'can_edit_landing_pages']),
			// },
			// {
			// 	component: CNavGroup,
			// 	name: 'Landing Pages',
			// 	to: '/landing-pages',
			// 	icon: <CIcon icon={cilBrowser} customClassName='nav-icon' />,
			// 	show: true,
			// 	items: [
			// 		{
			// 			component: CNavItem,
			// 			name: 'List Pages',
			// 			to: '/landing-pages',
			// 			icon: <CIcon icon={cilList} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_view_landing_pages']),
			// 		},
			// 		{
			// 			component: CNavItem,
			// 			name: 'Create Page',
			// 			to: '/create/landing-page',
			// 			icon: <CIcon icon={cilPencil} customClassName='nav-icon' />,
			// 			show: hasAnyRights(user, ['can_edit_landing_pages']),
			// 		},
			// 	],
			// },

			{
				component: CNavItem,
				name: 'Posters',
				classNames: 'posters',
				to: '/manage/posters',
				icon: <ImageIcon weight="bold" className='nav-icon' size={16} />,
				show: [0, 1, 2, 3, 4].includes(user?.accessLevel),
			},

			{
				component: CNavTitle,
				name: 'PHISHING REPORTER',
				show: hasAnyRights(user, ['can_view_phishing_reports', 'can_edit_phishing_reports']) && hasServiceRights('email', currentCustomer),
			},
			{
				component: CNavItem,
				name: 'Reports',
				classNames: 'reports',
				to: '/phish/reports',
				icon: <FlagIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_phishing_reports']) && hasServiceRights('email', currentCustomer),
			},

			{
				component: CNavTitle,
				name: 'FEEDS ',
				show: hasAnyRights(user, [
					'can_view_cyber_news_feeds',
				]),
			},
			{
				component: CNavItem,
				name: 'News Feeds',
				classNames: 'news_Feeds',
				to: '/Newsfeeds',
				icon: <NewspaperIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_cyber_news_feeds']) && hasServiceRights('email', currentCustomer),
			},


			{
				component: CNavTitle,
				name: 'SETTINGS ',
				show: hasAnyRights(user, [
					'can_view_email_campaigns',
					'can_edit_email_campaigns',
					'can_view_sms_campaigns',
					'can_edit_sms_campaigns',
					'can_view_whatsapp_campaigns',
					'can_edit_whatsapp_campaigns',
					'can_view_voice_campaigns',
					'can_edit_voice_campaigns',
				]),
			},
			{
				component: CNavItem,
				name: 'Categories',
				to: '/categories-Operations',
				icon: <ListBulletsIcon weight="bold" className='nav-icon' size={16} />,
				show: [0, 1].includes(user?.accessLevel)
			},
			{
				component: CNavItem,
				name: 'LandingPage',
				to: '/manage/landing-pages',
				icon: <BrowserIcon weight="bold" className='nav-icon' size={16} />,
				show: [0, 1, 2, 3].includes(user?.accessLevel)
			},
			// {
			// 	component: CNavItem,
			// 	name: 'Poster',
			// 	to: '/poster-new',
			// 	icon: <CIcon icon={cilImage} customClassName='nav-icon' />,
			// 	show: [0, 1].includes(user?.accessLevel)
			// },
			{
				component: CNavItem,
				name: 'System Notifiers',
				classNames: 'systemNotifiers',
				to: '/system/templates',
				icon: <EnvelopeIcon weight="bold" className='nav-icon' size={16} />,
				show: hasAnyRights(user, ['can_view_system_templates']),
			},
			{
				component: CNavItem,
				name: 'Instruction Manual',
				classNames: 'instructionManual',
				to: '/Instructionmanual',
				icon: <BookIcon weight="bold" className='nav-icon' size={16} />,
				show: hasServiceRights('email', currentCustomer),
			},
		];
		return _nav;
	},
};

export default navigation;
